import { Alert } from '@/components/ui/Alert';

/**
 * A screen that could not load what it needs, and the way back.
 *
 * Eighteen screens had written this out themselves, and the copies had already
 * drifted — some offered a retry and some left the reader stranded on a dead
 * page (CLAUDE.md §3, §6: every screen handles loading, empty, error and
 * success).
 *
 * The server's own sentence is shown rather than a wording of ours: it names
 * what actually went wrong — a section already full, a number already on the
 * roll — and replacing that with "Something went wrong" throws away the only
 * part the reader could have acted on.
 */
export interface QueryErrorProps {
  /** What failed to load, in the reader's terms: "Could not load the register". */
  title: string;
  /** Whatever `useApiQuery` handed back. */
  error: { message: string };
  /** Omitted when there is nothing sensible to retry — the alert still shows. */
  onRetry?: () => void;
}

export function QueryError({ title, error, onRetry }: QueryErrorProps) {
  return (
    <Alert tone="critical" title={title}>
      {error.message}
      {onRetry && (
        <>
          {' '}
          <button type="button" onClick={onRetry} className="font-[560] underline">
            Try again
          </button>
        </>
      )}
    </Alert>
  );
}
